import { setType } from 'redux/slices/search';
import { dropDownStyle } from 'components/InitialStyle';
import { Box, Checkbox, Menu, MenuItem } from '@mui/material';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

type Props = {
  setShow: any;
  anchorEl: any;
  open: boolean;
  close: () => void;
};

const data = [
  {
    name: 'Все',
    type: 'all',
  },
  {
    name: 'Активные',
    type: 'active',
  },
  {
    name: 'Не активные',
    type: 'in_active',
  },
  {
    name: 'В архиве',
    type: 'archive',
  },
  {
    name: 'Досрочно закрытые',
    type: 'closed',
  },
];

export default function FilterComponent({ open, close, anchorEl, setShow }: Props) {
  const dispatch = useDispatch();
  const { type } = useSelector((selector: any) => selector.search, shallowEqual);

  const handleCheckboxChange = (id: string) => dispatch(setType(id));

  return (
    <Box>
      <Menu
        anchorEl={anchorEl}
        id='account-menu'
        open={open}
        onClose={close}
        PaperProps={{
          elevation: 0,
          sx: dropDownStyle,
        }}
        transformOrigin={{ horizontal: 'left', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}>
        <MenuItem
          disableRipple
          sx={{
            '&:hover': {
              backgroundColor: '#fff',
            },
            backgroundColor: '#fff',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}>
          <Box>
            {data?.map((i: { name: string; type: string }) => (
              <Box key={i.name} display='flex' alignItems='center'>
                <Checkbox
                  size='small'
                  sx={{
                    width: '14px',
                    height: '14px',
                    marginRight: '8px',
                  }}
                  disableRipple
                  checked={type === i.type}
                  onChange={(e) => {
                    e.stopPropagation();
                    handleCheckboxChange(i.type);
                    setShow(true);
                  }}
                />
                {i.name}
              </Box>
            ))}
          </Box>
        </MenuItem>
      </Menu>
    </Box>
  );
}
